import { useState, useRef, useEffect } from 'react'
import Tabs from '../../../../Components/Tabs'
import GetIcon from '../../../../utils/Icon'
import Tab1 from './Tab1'
import Table from './Table'
import Button from '../../../../Core/Button/Button'
import ApiResponseBox from '../../../../Components/ApiResponseBox'
import { useGetPickDetailQuery, usePostSubmitAssemblyPickMutation, usePostUpdateAssemblyPickMutation } from '../../../../store/api/assemblyapi'
import { useNavigate } from 'react-router-dom'


function Pick({ order_id }) {
    const nvg = useNavigate()
    const scanItemRef = useRef(null);
    const [tab, settab] = useState(1)
    const [result, setResult] = useState(false)
    const [error, setError] = useState('');
    const [ptype, setptype] = useState("Error")
    const [showError, setShowError] = useState(false);
    const [scannedBin, setScannedBin] = useState('');
    const [scannedItem, setScannedItem] = useState('');
    const [scanboll, setscanboll] = useState(false);
    const [submit, setsubmit] = useState(false);
    const [selectRow, setselectRow] = useState("");
    const { data: pickdetail, isLoading: pickLoader } = useGetPickDetailQuery(order_id);
    const [fulldata, setfulldata] = useState();
    const [originalItems, setOriginalItems] = useState([]);
    const [item_Rows, setitem_Rows] = useState([]);
    const [itemList, setItemList] = useState([]);
    

    const handleBinScan = (e) => {
        scanItemRef.current?.focus();
        e.preventDefault();
        if (scannedBin.trim()) {
            const filtered = originalItems.filter(item => item.warehouse === scannedBin.trim());
            setitem_Rows(filtered);
        } else {
            handleClearBinFilter();
        }
    };
    const handleClearBinFilter = () => {
        setScannedBin('');
        setitem_Rows(originalItems);
    };
    const handleItemScan = (e) => {
        e.preventDefault();
        setScannedItem("");

        if (scannedItem.trim()) {
            let flag = false;
            let matchedItem = null;

            try {
                const filtered = item_Rows.map((item) => {
                    if (!(item.warehouse == scannedBin.trim())) {
                        throw "Item needs to be in the same Warehouse";
                    }

                    if (item.item_code === scannedItem.trim()) {
                        const currentPickedQty = parseInt(item.scanned_picked_qty || 0);
                        const totalQty = parseInt(item.qty || 0);

                        if (currentPickedQty >= totalQty) {
                            throw "Picked quantity exceeds available quantity";
                        }

                        item.scanned_picked_qty = currentPickedQty + 1;
                        flag = true;
                        matchedItem = { ...item };
                    }

                    return item;
                });

                if (flag && matchedItem) {
                    const updatedList = [
                        matchedItem,
                        ...filtered.filter((item) => item.item_code !== matchedItem.item_code),
                    ];

                    setitem_Rows(updatedList);
                    setselectRow(matchedItem);
                } else {
                    alert("Product Not Found");
                }
            } catch (err) {
                alert(err);
                console.log(err);
            }
        }
    };





    useEffect(() => {
        if (!pickLoader) {
            setfulldata(pickdetail);
            let updatedRows = pickdetail.data.locations.map(item => ({
                ...item,
                scanned_picked_qty: 0,
            }));
            setItemList(updatedRows);
            setOriginalItems(updatedRows);
            setitem_Rows(updatedRows);
        }
    }, [pickdetail, pickLoader]);


    const totalPickedQty = item_Rows.reduce((total, item) => {
        return total + (Number(item.picked_qty) || 0);
    }, 0);

    const totalQty = item_Rows.reduce((total, item) => {
        return total + (item.order_qty || 0);
    }, 0);
    const totalaccepted = item_Rows.reduce((total, item) => {
        return total + (item.qty || 0);
    }, 0);

    const [UpdatePick] = usePostUpdateAssemblyPickMutation()
    const handleClicksave = () => {
        const payload = {
            name: order_id,
            locations: item_Rows.map(item => ({
                name: item.name,
                qty: item.qty,
                picked_qty: parseInt(item.scanned_picked_qty)
            }))
        };
        const invalidItems = item_Rows.filter(item => parseInt(item.scanned_picked_qty) !== item.qty);

        if (invalidItems.length > 0) {
            const invalidNames = invalidItems.map(item => item.item_code).join(", ");
            setptype('Error');
            setError(`Validation failed: Picked quantity must equal quantity for these items: ${invalidNames}`);
            setShowError(true);
            return;
        }
        const updateRes = UpdatePick(payload).unwrap();
        setResult(true)

        setptype('Success');
        setError(`Pick Saved Successfully`);
        setShowError(true);
    };
    const [submitPick] = usePostSubmitAssemblyPickMutation();
    const handleClicksubmit = async () => {
        try {
            const ResponseData = await submitPick({ "pick_list_name": order_id })
            setptype("Message")
            setError("Pick Sumbit Successfully");
            setShowError(true);
            nvg(`/assmbly/view-work-order`, { state: { assemblyID: ResponseData.data.message.work_order } })

            setTimeout(() => {

                setptype("")
                setError("");
                setShowError(false);
            }, 4000);

        } catch (error) {

        }
    };


    return (
        !pickLoader && <>
            <Tabs />
            <div className="d-flex justify-content-between px-2 " style={{ background: "#fcfdfe", height: '40px' }}>
                <div className="d-flex align-items-center customizewidth">
                    <p className="m-0 breadcrumb-item">Outbound</p>
                    <p className="m-0 "> <GetIcon iconName="MdOutlineKeyboardArrowRight" size={13} /> </p>
                    <p className="m-0 breadcrumb-item">Pick List </p>
                    <p className="m-0 ">  <GetIcon iconName="MdOutlineKeyboardArrowRight" size={13} />  </p>
                    <a href="javascript:void(0);" className="pagetitle d-flex align-items-center mainpage" style={{ borderBottom: "0px solid", textWrap: "nowrap", gap: '5px', color: "#270B79" }} >
                        New Pick
                        <button
                            className={` ${submit
                                ? 'rounded-pill newdesign123'
                                : 'rounded-pill newdesign2343'
                                }`}
                        >
                            {submit ? 'Submitted' : result ? 'Draft' : 'New'}
                        </button>
                    </a>
                </div>
                <div className="d-flex align-items-center justify-content-end customizewidth" style={{ gap: '5px' }} >





                    {!submit && (

                        <Button
                            style={{ gap: '2px' }}
                            className="custom-btn-00989"
                            iconName="LuFilePlus2"
                            iconSize={12}
                            onClick={() => { result ? handleClicksubmit() : handleClicksave() }}
                        // disabled={isLoading}
                        >
                            {result ? 'Submit' : 'Save'}
                        </Button>
                    )}




                </div>
            </div>
            <div className="d-flex flex-column" style={{ width: "100%", overflow: "hidden", backgroundColor: "#fff",flexGrow:'1' }}>
                <div className="col-12 p-0" style={{ backgroundColor: '#eff4f9' }}>
                    <div className="d-flex justify-content-between align-items-end ">
                        <ul
                            className="nav nav-tabs mb-0"
                            style={{ color: "white", border: "none" }}
                        >
                            <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner">
                                <a
                                    className={tab == 1 ? "nav-link active-tab-custom text-white border-radius-top-corner" : "nav-link nav-link-tab-custom bg-white border-radius-top-corner"}
                                    onClick={() => { settab(1) }}
                                    href="javascript:void(0);"
                                >
                                    General Details
                                    {tab == 1
                                        ? <GetIcon iconName="MdKeyboardArrowDown" size={15} />
                                        : <GetIcon iconName="MdKeyboardArrowRight" size={15} />}
                                </a>
                            </li>
                        </ul>
                        <div className="d-flex align-items-center mb-2 px-3" style={{ gap: "2px", fontSize: '12px' }}>
                            <span style={{ position: 'relative', top: '-1px' }}>
                                <GetIcon iconName="CgAttachment" size={12} />
                            </span>
                            <span className=" fw-semibold" style={{ color: "#391F84" }}>
                                Attachments
                            </span>
                        </div>
                    </div>
                </div>
                <div className="row d-flex justify-content-between" style={{ marginTop: '14px' }}>
                    <div className="col-3 " style={{ visibility: tab == 1 ? "visible" : 'hidden', height: tab == 1 ? "auto" : '0px' }}>
                        <Tab1 fulldata={pickdetail.data} />
                    </div>
                    <div className="col-9" style={{ visibility: tab == 1 ? "visible" : 'hidden', height: tab == 1 ? "auto" : '0px' }}>
                        <div className="d-flex justify-content-between align-items-center pb-2" style={{ gap: '5px' }}>
                            <div className="d-flex" style={{ gap: '10px' }}>
                                <p className="NoOfLine">
                                    No. of lines - <span style={{ color: '#2563EB' }}>{item_Rows.length}</span>
                                </p>
                                <p className="TotalQty">
                                    Total Quantity - <span style={{ color: '#16A34A' }}>{totalaccepted > 0 ? totalaccepted : totalQty}</span>
                                </p>
                                <p className="ReceivedQty">
                                    Scanned Quantity - <span style={{ color: '#EC642A' }}>{item_Rows.reduce((total, item) => {
                                        return total + (parseInt(item.scanned_picked_qty) || 0);
                                    }, 0)}</span>
                                </p>
                            </div>

                            <div className="d-flex mx-2" style={{ gap: '10px', borderColor: 'rgba(0,0,0,0.2)' }}>
                                <form onSubmit={handleBinScan}>
                                    <div className="position-relative">
                                        <input
                                            type="text"
                                            name="binScan"
                                            placeholder="Scan Bin"
                                            className="form-control pe-4"
                                            value={scannedBin}
                                            onChange={(e) => setScannedBin(e.target.value)}
                                            style={{
                                                width: '227px',
                                                border: '1px solid #333',
                                                fontSize: '0.8rem'
                                            }}
                                        />
                                        <button
                                            type="submit"
                                            className="position-absolute"
                                            style={{
                                                top: '50%',
                                                right: '10px',
                                                transform: 'translateY(-50%)',
                                                background: 'none',
                                                border: 'none',
                                                padding: 0,
                                                cursor: 'pointer',
                                                color: "#EC642A"
                                            }}
                                        >
                                            <GetIcon iconName="BsUpcScan" design="cursor-pointer" size={15} />
                                        </button>
                                    </div>
                                </form>



                                <form onSubmit={handleItemScan}>
                                    <div className="position-relative" style={{ width: '227px' }}>
                                        <div
                                            style={{ position: 'relative' }}
                                            title={!scannedBin ? 'Scan Bin' : ''}
                                        >
                                            <input
                                                ref={scanItemRef}
                                                type="text"
                                                placeholder="Scan Item"
                                                className="form-control pe-4"
                                                value={scannedItem}
                                                onChange={(e) => setScannedItem(e.target.value)}
                                                disabled={!scannedBin}
                                                style={{
                                                    fontSize: '0.8rem',
                                                    width: '100%',
                                                    border: '1px solid #333',
                                                    backgroundColor: !scannedBin ? '#f1f1f1' : 'white',
                                                    cursor: !scannedBin ? 'not-allowed' : 'text',
                                                }}
                                            />

                                            {!scannedBin && (
                                                <div
                                                    style={{
                                                        position: 'absolute',
                                                        top: '50%',
                                                        right: '40px',
                                                        transform: 'translateY(-50%)',
                                                        pointerEvents: 'none',
                                                        color: '#999',
                                                    }}
                                                >
                                                    <GetIcon iconName="MdBlock" size={16} />
                                                </div>
                                            )}
                                        </div>

                                        <button
                                            type="submit"
                                            className="position-absolute"
                                            disabled={!scannedBin}
                                            style={{
                                                top: '50%',
                                                right: '10px',
                                                transform: 'translateY(-50%)',
                                                background: 'none',
                                                border: 'none',
                                                padding: 0,
                                                cursor: !scannedBin ? 'not-allowed' : 'pointer',
                                                color: "#EC642A",
                                            }}
                                            title={!scannedBin ? 'Scan Bin' : 'Submit'}
                                        >
                                            <GetIcon iconName="BsUpcScan" design="cursor-pointer" size={15} />
                                        </button>
                                    </div>

                                </form>
                            </div>

                        </div>

                        <div className="tableLabel">
                            <div style={{ width: '98.5%', borderBottom: '1px solid #caced3', fontSize: '15px', marginBottom: '2px' }}></div>
                            <p style={{ color: "#1E1E1E", fontWeight: '500', margin: '0px' }}>
                                Item Details
                            </p>
                        </div>
                        <Table list_data={itemList} fulldata={fulldata} row={{ Rows: item_Rows, setRows: setitem_Rows, selectRow }} scanboll={scanboll} submit={submit} />
                    </div>
                </div>

                <ApiResponseBox
                    poptype={ptype}
                    show={showError}
                    errorMessage={error}
                    onClose={() => setShowError(false)}
                />
            </div>
        </>
    )
}

export default Pick